/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */
import React from 'react'
import { useServiceContext } from '../root'
import { useModal } from '../contexts/ModalContext'
import DocumentMigrationModal from '../pages/browser/document-migration/DocumentMigrationModal'

// Stub DocMigration for development if not available
// Remove this stub and import the real component when available
const DocMigration: React.FC<any> = (props) => (
  <div style={{ padding: 24, background: '#f5f5f5', border: '1px solid #ccc', borderRadius: 4 }}>
    <strong>DocMigration Stub</strong>
    <pre style={{ fontSize: 12, marginTop: 8 }}>{JSON.stringify(props, null, 2)}</pre>
  </div>
)

interface FolderInfo {
  systemFolderType: string
  templateId: string
}

function useDocUploadDataService() {
  const context = useServiceContext()
  const { service } = context
  const { showModal } = useModal()

  const assembleDocUploadData = async (): Promise<void> => {
    try {
      const [folderInfoRes, folderIdRes] = await Promise.allSettled([
        service.staging.getStagingFolderInfo(),
        service.staging.getStagingUploadFolderId()
      ])

      if (folderInfoRes.status === 'fulfilled' && folderIdRes.status === 'fulfilled') {
        const folderInfo = folderInfoRes.value as FolderInfo
        const folderId = folderIdRes.value as string | number

        showModal(
          <DocumentMigrationModal
            isOpen={true}
            onClose={() => {}}
            folderId={typeof folderId === 'number' ? folderId : Number(folderId)}
            isSiteUpload={true}
            params={{
              parentFolderType: folderInfo.systemFolderType,
              templateId: folderInfo.templateId ? Number(folderInfo.templateId) : undefined,
              isSiteUpload: true
            }}
          />
        )
      } else {
        // Log which call(s) failed for debugging
        if (folderInfoRes.status === 'rejected') {
          console.error('Failed to get staging folder info:', folderInfoRes.reason)
        }
        if (folderIdRes.status === 'rejected') {
          console.error('Failed to get staging upload folder ID:', folderIdRes.reason)
        }

        service.toast.error('AMPRIDATVIR_ERR_FORM_MODAL_TITLE')
        throw new Error('One or both async calls failed.')
      }
    } catch (err) {
      console.error('Error occurred:', err)
    }
  }

  return {
    assembleDocUploadData
  }
}

export default useDocUploadDataService
